module.exports = __webpack_public_path__ + "static/media/carousel-right-button.0d5fde02.svg";